// src/lib/kolTabs.js
//
// The creator page's tabs, in order (mission 014-01: Founding Drop last;
// 032-01: Posts · Live (only while live) · Founding Drop). Kept outside KOLDetailPage so the order is testable.

import { Lock, Radio, TrendingUp } from 'lucide-react';

export function kolTabs({ creatorIsLive = false } = {}) {
  return [
    // "Collections" (013-06) → "Posts" (031-01): the creator's home — the post
    // feed with the rail of live / next rooms / reels / replays (032-01). The
    // id stays 'collections' so old URLs keep working (resolveKolTab).
    { id: 'collections', label: 'Posts', icon: Lock },
    // 032-01: rooms are states of the creator, not a destination — the Rooms
    // tab became a Live tab that exists ONLY while the creator is live (its
    // body is the live room). Offline, scheduled rooms live in the Posts rail.
    ...(creatorIsLive ? [{ id: 'live', label: 'Live', icon: Radio, live: true }] : []),
    // "Market" implies a price that moves. The founding drop is one fixed
    // price and 100 units, so the tab is named for the thing, not a market.
    { id: 'market', label: 'Founding Drop', icon: TrendingUp },
  ];
}

/** The tab a ?tab= value opens, or null for an unknown value. 'content' (the
 *  Posts tab's old id) and 'replays' land on Posts; 'rooms' (the old tab) and
 *  'live' ask for Live — the page falls back to Posts (at Upcoming) when the
 *  creator isn't live (see kolTabView). */
export function resolveKolTab(param) {
  if (param === 'collections' || param === 'content' || param === 'replays') return 'collections';
  if (param === 'rooms' || param === 'live') return 'live';
  if (param === 'market') return 'market';
  return null;
}

/** 032-01: what a ?tab= value shows INSIDE Posts — 'replays' (the catalogue as
 *  the main column), 'upcoming' (scrolled to that module when the Live tab
 *  isn't there), else null. */
export function kolTabView(param) {
  if (param === 'replays') return 'replays';
  if (param === 'rooms' || param === 'live') return 'upcoming';
  return null;
}
